import ImageWithPreview from "./ImageWithPreview";

export const markdownStyles = {
  a: (props) => (
    <a
      {...props}
      className="text-blue-600 hover:text-blue-800 underline transition-colors duration-200"
      target="_blank"
      rel="noopener noreferrer"
    />
  ),
  table: (props) => (
    <table
      className="w-full table-auto border border-gray-400 rounded-lg overflow-hidden text-sm"
      {...props}
    />
  ),
  thead: (props) => (
    <thead className="bg-gray-800 text-white font-bold text-left" {...props} />
  ),
  th: (props) => (
    <th
      className="border border-gray-400 px-4 py-2 text-left font-semibold bg-gray-800 text-white"
      {...props}
    />
  ),
  td: (props) => (
    <td
      className="border border-gray-400 px-4 py-2 align-top bg-white text-gray-900"
      {...props}
    />
  ),
  tr: (props) => (
    <tr className="hover:bg-gray-100 transition-colors" {...props} />
  ),
  img: (props) => {
    if (props.disableImage) return null;
    return <ImageWithPreview {...props} />;
  },
  ol: (props) => (
    <ol
    {...props}
      className="ol-with-img"
    />
  ),
  ul: (props) => (
    <ul
    {...props}
      className="ul-with-img"
    />
  )
};
